import DashboardLayout from "@/components/DashboardLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "wouter";

/** Friendly denial when Inventory/Procurement hit create/edit/revise routes. */
export default function ProposalMutationForbiddenPage({
  title = "Read-only access",
  description = "Your Inventory / Procurement role can view proposals but cannot create, edit, revise, or send them.",
  backHref = "/sales/proposals",
  backLabel = "Back to Proposals",
}: {
  title?: string;
  description?: string;
  backHref?: string;
  backLabel?: string;
}) {
  return (
    <DashboardLayout>
      <div className="mx-auto max-w-lg p-6" data-testid="proposal-mutation-forbidden">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">{title}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">{description}</p>
            <Button asChild>
              <Link href={backHref}>{backLabel}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
